import React from 'react';
import { Grid, Table, Segment, Message } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import moment from 'moment';

const PaymentDetails = ({ orderId, loading, details }) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  if (!orderId) {
    return (
      <Message
        icon="info"
        color="yellow"
        header="Not Found"
        content="Seems like the order Id is invalid or there is no record available"
      />
    );
  }

  return (
    <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
      <Helmet>
        <title>Payment Details</title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={3} textAlign="center">
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Payment Details
          </h2>
          <h3 style={{ fontWeight: 400 }}>Order Id: {orderId}</h3>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={10}>
          {details &&
            details.length &&
            details.map(el => (
              <React.Fragment>
                <Table fixed unstackable>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>ID</Table.HeaderCell>
                      <Table.HeaderCell>Payment Gateway</Table.HeaderCell>
                      <Table.HeaderCell>Payment Gateway ID</Table.HeaderCell>
                      <Table.HeaderCell>Cart ID</Table.HeaderCell>
                      <Table.HeaderCell>Amount</Table.HeaderCell>
                      <Table.HeaderCell>Status</Table.HeaderCell>
                      <Table.HeaderCell>Created At</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>{el.id}</Table.Cell>
                      <Table.Cell>{el.payment_gateway_name}</Table.Cell>
                      <Table.Cell>{el.payment_gateway_id}</Table.Cell>
                      <Table.Cell>{el.cart_id}</Table.Cell>
                      <Table.Cell>Rs. {el.amount}</Table.Cell>
                      <Table.Cell>{el.status}</Table.Cell>
                      <Table.Cell>
                        {/* {new Date(el.created_at).toLocaleDateString()} */}
                        {moment
                          .utc(el.created_at)
                          .local()
                          .format('DD-MM-YYYY HH:mm:ss')}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <Segment content>
                  <h3>Gateway Response</h3>
                  <p style={{ overflowWrap: 'break-word' }}>
                    {JSON.stringify(el.gateway_response)}
                  </p>
                </Segment>
                <hr style={{ width: '50%' }} />
              </React.Fragment>
            ))}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
export default PaymentDetails;



// WEBPACK FOOTER //
// ./src/Modules/PaymentDetails/component.jsx